<template>
  <div class="settings-main">
    <List>
      <div class="item-header">
        {{ $l.appInfo }}
      </div>

      <div class="item" @click="selectLanguage()">
        <div class="item-left">
          言語 Language
        </div>
        <div class="item-right">
          {{ $l[$store.getters['locale/current']] }}
        </div>
      </div>

      <div class="item">
        <div class="item-left">
          {{ $l.version }}
        </div>
        <div class="item-right">
          1.0.0
        </div>
      </div>

      <div class="item" @click="openManual()">
        {{ $l.manual }}
      </div>

      <div class="item" @click="openTermsOfService()">
        {{ $l.termsAndConditions }}
      </div>

      <div class="item" @click="openCommercialTransaction()">
        {{ $l.actOnSpecifiedCommercialTransactions }}
      </div>

      <div class="item" @click="openPrivacyPolicy()">
        {{ $l.privacyPolicy }}
      </div>

      <div class="item" @click="openContact()">
        {{ $l.contact }}
      </div>

      <div class="item-header">
        {{ $l.userInfo }}
      </div>

      <div class="item" @click="$router.push({ name: 'settings-login' })">
        {{ $l.loginInfo }}
      </div>

      <div class="item" @click="$router.push({ name: 'settings-user' })">
        {{ $l.commonInfo }}
      </div>

      <div class="item" @click="$router.push({ name: 'settings-bank' })">
        {{ $l.bankInfo }}
      </div>

      <div class="item" @click="logout">
        {{ $l.logout }}
      </div>
    </List>
  </div>
</template>

<script>
import Parse from 'parse'
import MixinLocale from '@/components/MixinLocale'
import List from '@/components/List'

export default {
  mixins: [ MixinLocale ],
  components: {
    List
  },

  methods: {
    logout: async function () {
      await Parse.User.logOut()
      this.$router.push({ name: 'login' })
    },

    selectLanguage: function () {
      this.$store.dispatch('popup/show', 'language')
    },

    openManual: function () {
      window.open(this.$l.urlManual, '_blank')
    },

    openTermsOfService: function () {
      window.open(this.$l.urlTermsAndConditions, '_blank')
    },

    openCommercialTransaction: function () {
      window.open(this.$l.urlCommercialTransaction, '_blank')
    },

    openPrivacyPolicy: function () {
      window.open(this.$l.urlPrivacyPolicy, '_blank')
    },

    openContact: function () {
      window.open(this.$l.urlContact, '_blank')
    }
  }
}
</script>

<style lang="scss" scoped>
.settings-main {
}
</style>
